/**
 * @author Christine Daneau-Pelletier <christine.daneau.pelletier@gmail.com>
 * @file Accordions
 * @description menu & blocks of accordions
 */


export class Accordions {

  // ATTRIBUTS //
  private btns:NodeListOf<HTMLElement>;
  private links:NodeListOf<HTMLElement>;
  readonly open_bind:any;

  // METHODS //
  /**
   * Constructor & initialise
   */
  public constructor() {
    this.open_bind = this.open.bind(this);
    this.btns = document.querySelectorAll('.accordion-trigger');
    this.links = document.querySelectorAll('.accordion-content a, .accordion-content button, .accordion-content input');

    this.init();
  }


  /**
   * Define the initial state
   */
  private init():void {

    this.btns.forEach((btn) => {
      btn.addEventListener('click', this.open_bind);

      // fix menu
      if (window.innerWidth > 800 && btn.classList.contains('menu-link')) {
        btn.removeEventListener('click', this.open_bind);
      }
      window.addEventListener("resize", () => {
        if (btn.classList.contains('menu-link')) {
          if (window.innerWidth > 800 && btn.classList.contains('menu-link')) {
            btn.removeEventListener('click', this.open_bind);
          }
          else {
            btn.addEventListener('click', this.open_bind);
          }
        }
      });

      // set height load for animation
      let $container = btn.closest('.accordion-item');
      // @ts-ignore
      $container.querySelector('.accordion-content').style.height = '0px';

      //$container.querySelector('.accordion-content').style.height = $container.querySelector('.accordion-content-inner').clientHeight + 'px';
    });

    // accessibility
    this.links.forEach((link) => {
      link.setAttribute('tabindex', '-1');
    });
  }



  /**
   * Open & close this accordion
   */
  private open(e):void {
    let $el = e.currentTarget;
    let $parent:HTMLElement = $el.closest('.accordion-item');
    let $container = $el.nextElementSibling;
    let $inner:HTMLElement = $container.querySelector('.accordion-content-inner');

    // reset for filters
    if ($el.classList.contains('hub-filters-label') && $parent.classList.contains('close')) {
      document.querySelectorAll('.hub-filters-group').forEach((el) => {
        el.classList.add('close');
        el.querySelector('.accordion-trigger').setAttribute('aria-pressed', 'false');
        el.querySelector('.accordion-trigger').setAttribute('aria-expanded', 'false');
        el.querySelector('.accordion-content').setAttribute('aria-hidden', 'true');
      })
    }

    // switch
    $parent.classList.toggle('close');


    // open
    if ($parent.classList.contains('close')) {
      $parent.querySelectorAll('[aria-expanded="true"]').forEach((el) => {
        el.setAttribute('aria-expanded', 'false');
      });
      $parent.querySelectorAll('[aria-pressed="true"]').forEach((el) => {
        el.setAttribute('aria-pressed', 'false');
      });
      $container.querySelectorAll('a, button, input').forEach((el) => {
        el.setAttribute('tabindex', '-1');
      });

      $container.style.height = '0px';
      $container.setAttribute('aria-hidden', 'true');

      //$el.querySelector('.accordion-icon').setAttribute('aria-label', $el.querySelector('.accordion-icon').dataset.open);
    }

    // close
    else {
      $parent.querySelectorAll('[aria-expanded="false"]').forEach((el) => {
        el.setAttribute('aria-expanded', 'true');
      });
      $parent.querySelectorAll('[aria-pressed="false"]').forEach((el) => {
        el.setAttribute('aria-pressed', 'true');
      });
      $container.querySelectorAll('a, button, input').forEach((el) => {
        el.setAttribute('tabindex', '0');
      });

      $container.setAttribute('aria-hidden', 'false');
      $container.style.height = $inner.clientHeight + 'px';

      //$el.querySelector('.accordion-icon').setAttribute('aria-label', $el.querySelector('.accordion-icon').dataset.close);
    }
  }
}
